import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'acabim-admin-asset-management',
  templateUrl: './asset-management.component.html',
  styleUrls: ['./asset-management.component.scss']
})
export class AssetManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  showLocation(value: any): void {
    console.dir(value);
  }

} // EOC
